import { render } from "./ViewsSurveyDeliveryFaq.vue?vue&type=template&id=ad9fb62e"
import script from "./ViewsSurveyDeliveryFaq.vue?vue&type=script&lang=js"
export * from "./ViewsSurveyDeliveryFaq.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__